import React from 'react';
import { BrowserRouter, Route, Routes } from 'react-router-dom';
import { Header } from './components/Header';
import { Footer } from './components/Footer';
import { Home } from './pages/Home';
import { ThingsToDoHub } from './pages/ThingsToDoHub';
import { ParksHub } from './pages/ParksHub';
import { ClassesHub } from './pages/ClassesHub';
import { ParentsHub } from './pages/ParentsHub';
import { Attractions } from './pages/Attractions';
import { Beaches } from './pages/Beaches';
import { Birthdays } from './pages/Birthdays';
import { Place } from './pages/Place';
import { Events } from './pages/Events';
import { BlogPost } from './pages/BlogPost';
import { About } from './pages/About';
import { SiteStructure } from './pages/SiteStructure';
export function App() {
  return <BrowserRouter data-id="element-0" data-mp="28ufqch5lbolp">
      <div className="flex min-h-screen w-full flex-col bg-paper font-sans" data-id="element-1" data-mp="28tw4wqgqei2x">
        <a href="#main" className="label sr-only focus:not-sr-only focus:absolute focus:left-4 focus:top-4 focus:z-50 focus:bg-ink focus:px-6 focus:py-3 focus:text-paper" data-id="element-2" data-mp="23vck4tdvjcc5">
          Skip to content
        </a>
        <Header data-id="element-3" data-mp="3mkhm3t5g125i" />
        <div className="flex-1" data-id="element-4" data-mp="3mjzs7369700r">
          <Routes data-id="element-5" data-mp="3mj6jhwnqi0fz">
            <Route path="/" element={<Home data-id="element-7" data-mp="3rdaq2et386gj" />} data-id="element-6" data-mp="3rcj31sdk3h1v" />
            <Route path="/things-to-do" element={<ThingsToDoHub data-id="element-9" data-mp="5yi8qe3h5da" />} data-id="element-8" data-mp="3rcsulke91w9o" />
            <Route path="/parks" element={<ParksHub data-id="element-11" data-mp="5gbgztt38r4" />} data-id="element-10" data-mp="682rygdekbl" />
            <Route path="/classes" element={<ClassesHub data-id="element-13" data-mp="2zlv6ktmtuzuj" />} data-id="element-12" data-mp="7sxbo2oq39g" />
            <Route path="/for-parents" element={<ParentsHub data-id="element-15" data-mp="2zng1wlgyumtg" />} data-id="element-14" data-mp="2zmo557bmuj1l" />
            <Route path="/attractions" element={<Attractions data-id="element-17" data-mp="33n6y54p9hv5d" />} data-id="element-16" data-mp="33m5eibu6k0c1" />
            <Route path="/beaches" element={<Beaches data-id="element-19" data-mp="38l8eviz7tido" />} data-id="element-18" data-mp="33oi0r16z0wuw" />
            <Route path="/birthday-parties" element={<Birthdays data-id="element-21" data-mp="38o4f5dyjcj5a" />} data-id="element-20" data-mp="38l06o4e1f18t" />
            <Route path="/place" element={<Place data-id="element-23" data-mp="3dlnt0crbmtwp" />} data-id="element-22" data-mp="3dle3sre3oqs2" />
            <Route path="/events" element={<Events data-id="element-25" data-mp="nvsub5qlapwh" />} data-id="element-24" data-mp="3dirtwl3qlz6o" />
            <Route path="/blog" element={<BlogPost data-id="element-27" data-mp="nvaqno1ll9ej" />} data-id="element-26" data-mp="nuhged3fk1rn" />
            <Route path="/about" element={<About data-id="element-29" data-mp="su427axbqqc2" />} data-id="element-28" data-mp="nxx05t81tyze" />
            <Route path="/site-structure" element={<SiteStructure data-id="element-31" data-mp="swgmhuqk1csa" />} data-id="element-30" data-mp="stc7s3fgqynd" />
            <Route path="*" element={<Home data-id="element-33" data-mp="356t1855fman" />} data-id="element-32" data-mp="35yn2ej3lbyt" />
          </Routes>
        </div>
        <Footer data-id="element-34" data-mp="3uct0zcywiaxb" />
      </div>
    </BrowserRouter>;
}